var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex align-center justify-space-between az-gap-small",
      attrs: { "data-test": _vm.dataTest }
    },
    [
      _c("div", [
        _c("p", { staticClass: "az-text-primary az-size-14 mb-0" }, [
          _vm._v(_vm._s(_vm.rotulo))
        ]),
        _vm.ajuda
          ? _c("p", { staticClass: "az-text-secondary az-size-12 mb-0" }, [
              _vm._v(_vm._s(_vm.ajuda))
            ])
          : _vm._e()
      ]),
      _c("v-switch", {
        staticClass: "mt-0 pt-0 flex-shrink-0",
        attrs: {
          "input-value": _vm.value,
          disabled: _vm.disabled,
          "hide-details": "",
          dense: "",
          "data-test": _vm.dataTest + "-toggle"
        },
        on: { change: _vm.aoMudar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }